import type { DetailedHTMLProps, InputHTMLAttributes } from "react";

export function Checkbox({ ...props }: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) {
  return (
    <input
      type="checkbox"
      className="size-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
      {...props}
    />
  );
}
